import {AccountInfo} from "../models/AccountInfo";

export default class AccountInfoUtils {

    static findDefaultAccount(accounts : AccountInfo[]) : AccountInfo | undefined {
        let defaultAccount = accounts.find(account => {return account.defaultAccount});

        return defaultAccount ?? accounts[0];
    }
}